<template>
  <div class="d-shortcuts__container">
    <DDropdown :isShowDots="false">
      <div class="d-drop-box" slot="title">{{ title }} <span class="icon-arrow-down52"></span></div>
      <ul slot="list">
        <li v-for="shortcut in shortcuts" :key="shortcut.val" @click="$emit('shortcutSelected', shortcut.dateRange)">
          {{ shortcut.title }}
        </li>
      </ul>
    </DDropdown>
  </div>
</template>
<script>
import DDropdown from '../common/DDropdown'
import moment from 'moment'

const I18N = {
  da: {
    choose_period: 'Vælg periode'
  },
  nb: {
    choose_period: 'Velg periode'
  },
  en: {
    choose_period: 'Choose period'
  }
}

export default {
  components: {DDropdown},
  props: {
    startDate: {
      default: () => moment()
    },
    endDate: {
      default: () => moment().add(1, 'days')
    },
    selectedStartDate: {
      default: () => null
    },
    selectedEndDate: {
      default: () => null
    }
  },
  computed: {
    locale () {
      return window.USER && window.USER.language ? window.USER.language : 'en'
    },
    i18n () {
      return I18N[this.locale]
    },
    title () {
      if (!this.selectedStartDate || !this.selectedEndDate) {
        return this.i18n['choose_period']
      }
      const dateRangeId = moment(this.selectedStartDate).format('YYYY-MM-DD') + '_' + moment(this.selectedEndDate).format('YYYY-MM-DD')
      const idx = this.shortcuts.findIndex(shortcut => shortcut.id === dateRangeId)
      if (idx < 0) {
        return this.i18n['choose_period']
      } else {
        return this.shortcuts[idx].title
      }
    },
    quartersInRange () {
      let startDate = this.startDate
      const dateRanges = []
      let currentDate = moment(startDate)
      const stopDate = moment(this.endDate)
      while (currentDate <= stopDate) {
        const intervalStart = moment(currentDate).format('YYYY-MM-DD')
        const intervalEnd = moment(currentDate).add(3, 'months').subtract(1, 'days').format('YYYY-MM-DD')
        dateRanges.push({start: intervalStart, end: intervalEnd})
        currentDate = moment(currentDate).add(3, 'months')
      }
      return dateRanges
    },
    getFirstWeekShortcut () {
      const startDate = moment(this.startDate).format('YYYY-MM-DD')
      const endDate = moment(this.startDate).add(6, 'days').format('YYYY-MM-DD')
      const startTitle = moment(startDate).format('ll')
      const endTitle = moment(endDate).format('ll')
      return {
        id: startDate + '_' + endDate,
        title: startTitle + ' - ' + endTitle,
        dateRange: {
          start: startDate,
          end: endDate
        }
      }
    },
    shortcuts () {
      const shortcuts = [this.getFirstWeekShortcut]
      this.quartersInRange.forEach(range => {
        const startTitle = moment(range.start).format('ll')
        const endTitle = moment(range.end).format('ll')
        const obj = {
          id: range.start + '_' + range.end,
          title: startTitle + ' - ' + endTitle,
          dateRange: {
            start: range.start,
            end: range.end
          }
        }
        shortcuts.push(obj)
      })
      return shortcuts
    }
  }
}
</script>

<style>

.d-shortcuts__container {
  min-width: fit-content;
}

.d-drop-box {
  background: #ffffff;
  padding: 0 0.75rem;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #acb6be;
}

.d-drop-box > span {
  margin-left: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// DatePickerRangeShortcuts.vue?590947b6